var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0502 17.28C12.0702 18.23 11.0002 18.08 9.97016 17.63C8.88016 17.17 7.88016 17.15 6.73016 17.63C5.29016 18.25 4.53016 18.07 3.67016 17.28C-1.20984 12.25 -0.489836 4.59 5.05016 4.31C6.40016 4.38 7.34016 5.05 8.13016 5.11C9.31016 4.87 10.4402 4.18 11.7002 4.27C13.2102 4.39 14.3502 4.99 15.1002 6.07C11.9802 7.94 12.7202 12.05 15.5802 13.2C15.0102 14.7 14.2702 16.19 13.0402 17.29L13.0502 17.28ZM8.03016 4.25C7.88016 2.02 9.69016 0.18 11.7702 0C12.0602 2.58 9.43016 4.5 8.03016 4.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.088b5534501c06cfe7a36ba032c3bdcd.svg";
export { ForwardRef as ReactComponent };